import type { Category } from '@/mocks/categories';

interface CategoryTabsProps {
  categories: Category[];
  activeSlug: string;
  onSelect: (slug: string) => void;
}

export default function CategoryTabs({ categories, activeSlug, onSelect }: CategoryTabsProps) {
  return (
    <div className="flex items-center gap-2 overflow-x-auto pb-2 scrollbar-hide">
      {categories.map((cat) => (
        <button
          key={cat.id}
          onClick={() => {
            onSelect(cat.slug);
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }}
          className={`flex items-center gap-2 px-4 py-2.5 rounded-full text-sm font-medium transition-all duration-300 whitespace-nowrap cursor-pointer ${
            activeSlug === cat.slug
              ? 'bg-primary-500 text-background-50'
              : 'bg-background-100 text-foreground-600 hover:bg-background-200'
          }`}
        >
          <div className="w-5 h-5 flex items-center justify-center">
            <i className={`${cat.icon} text-base`}></i>
          </div>
          {cat.name}
        </button>
      ))}
    </div>
  );
}